

import React from 'react';
import { faFile, faFileImage, faFilePdf } from '@fortawesome/pro-light-svg-icons';
import { Spin, Table} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Box, ShowIf, Text } from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import VerticalBox from '../../../shared/components/basic/VerticalBox';

function mimeTypeToIcon(mimeType) {
  let fileIcon = null;

  switch (mimeType) {
    case 'image/png':
    case 'image/jpeg':
      fileIcon = faFileImage;
      break;
    case 'application/pdf':
      fileIcon = faFilePdf;
      break;
    default:
      fileIcon = faFile;
      break;
  }
  return fileIcon;
}

export default function TablaFicheros({
  files, selectedRowKeys, onRowSelection, onEditarClicked,
}) {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'nombre',
      rowKey: (row) => {
        const { id } = row;
        return id;
      },
      render: (value, row) => {
        const {
          nombre,
          descripcion,
          mimeType,
          publicUrl,
          updating,
          requestState,
          esImagen
        } = row;
        const fileIcon = mimeTypeToIcon(mimeType);

        let tip = '';

        switch (requestState) {
          case 'deleting':
            tip = 'Eliminando archivo';
            break;
          case 'uploading':
            tip = 'Subiendo archivo';
            break;
          default:
            tip = 'Actualizando archivo';
            break;
        }

        const modoPrevisuallizacion = false;
        const ancho = (modoPrevisuallizacion === true) ? '128px' : '32px';
        const alto = (modoPrevisuallizacion === true) ? '128px' : 'auto';

        return (
          <Spin tip={tip} spinning={updating === true}>
            <TwoColumnsFlexLayout

              leftColumnStyle={{ maxWidth: ancho, height: alto }}

              leftContent={(
                <VerticalBox height={alto}>
                  <ShowIf condition={modoPrevisuallizacion}>
                    <ShowIf condition={esImagen}>
                      <a href={publicUrl} target="_blank" rel="noopener noreferrer">
                        <img alt="" style={{ width: '100%', border: '1px solid #dedede' }} src={publicUrl} />
                      </a>
                    </ShowIf>
                    <ShowIf condition={esImagen !== true}>
                      <Box style={{ textAlign: 'center'}}>
                        <FontAwesomeIcon icon={faFileImage} size="3x" color="lightgrey" />
                        <Text mt="8" color="lightgray">Previsualización no disponible</Text>
                      </Box>
                    </ShowIf>
                  </ShowIf>
                  <ShowIf condition={modoPrevisuallizacion !== true}>
                    <FontAwesomeIcon size="2x" icon={fileIcon} />
                  </ShowIf>
                </VerticalBox>
              )}

              rightContent={(
                <VerticalBox alignItems="baseline" height={alto}>
                  <Box pl="16">
                    <Text style={{ display: 'block' }}>
                      <a href={publicUrl} target="_blank" rel="noopener noreferrer">{nombre}</a>
                    </Text>
                    <ShowIf condition={descripcion}>
                      <Text mt="4" fontSize="12" color="gray">{descripcion}</Text>
                    </ShowIf>
                    <ShowIf condition={descripcion === null || descripcion === undefined || descripcion.length === 0}>
                      <Text mt="4" fontSize="12" color="gray">
                        <a onClick={() => onEditarClicked(row)}>Añadir descripción</a>
                      </Text>
                    </ShowIf>
                  </Box>
                </VerticalBox>
              )}
            />
          </Spin>
        );
      },
    },
    {
      title: 'Fecha',
      dataIndex: 'fechaCreacionFormateada',
      width: 80,
    },
    {
      render: (value, row) => {
        if (row.updating) return <div />;
        return <a onClick={() => onEditarClicked(row)}>Editar</a>;
      },
      width: 100,
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      onRowSelection(selectedRowKeys, selectedRows);
    },
    selectedRowKeys,
  };
  return <Table rowKey="id" rowSelection={rowSelection} pagination={false} showHeader={false} columns={columns} dataSource={files} />;
}
